/**
 * Configurações LGPD - USYS Tecnologia
 * Dados do Encarregado de Proteção de Dados (DPO) - atualizar conforme ata de nomeação
 */
export const DPO_CONTACT = {
  email: "dpo@usystech.com.br", // Substituir pelo e-mail real do DPO
  empresa: "USYS Tecnologia",
};

export const POLITICA_ULTIMA_ATUALIZACAO = "06/03/2026";
